import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Calendar, MapPin } from 'lucide-react';
import type { LoanData } from './types';

interface Props {
  loan: LoanData;
  sellerRuta: number;
  onComplete: (loan: LoanData) => void;
}

export default function ScheduleStep({ loan: initialLoan, sellerRuta, onComplete }: Props) {
  const [dates, setDates] = useState<Date[]>(initialLoan.installmentDates);

  useEffect(() => {
    if (initialLoan.installmentDates.length > 0) {
      setDates(initialLoan.installmentDates);
    }
  }, [initialLoan.installmentDates]);

  const handleDateChange = (date: Date | null, index: number) => {
    if (!date) return;
    setDates(prev => prev.map((d, i) => (i === index ? date : d)));
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-gray-900 mb-1">Agenda</h2>
        <p className="text-gray-600 text-sm">
          Confirme as datas de vencimento das parcelas.
        </p>
      </div>

      {/* Ruta — informativo, não editável */}
      <div className="bg-white border-2 border-gray-100 rounded-xl overflow-hidden">
        <div className="flex items-center gap-2 px-4 py-3 bg-gray-50 border-b border-gray-100">
          <MapPin className="w-4 h-4 text-gray-400" />
          <h3 className="text-sm font-semibold text-gray-700">Ruta</h3>
        </div>
        <div className="p-4 flex items-center gap-3">
          <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-blue-600 text-white font-bold text-lg">
            {sellerRuta}
          </span>
          <div>
            <p className="text-sm font-semibold text-gray-900">Ruta {sellerRuta}</p>
            <p className="text-xs text-gray-500">Definida pelo seu cadastro de vendedor</p>
          </div>
        </div>
      </div>

      {/* Datas das parcelas */}
      <div className="bg-white border-2 border-gray-100 rounded-xl overflow-hidden">
        <div className="flex items-center gap-2 px-4 py-3 bg-gray-50 border-b border-gray-100">
          <Calendar className="w-4 h-4 text-gray-400" />
          <h3 className="text-sm font-semibold text-gray-700">Datas das Parcelas</h3>
        </div>
        <div className="p-4 space-y-3">
          {dates.map((date, index) => (
            <div key={index} className="flex items-center gap-3">
              <span className="flex-shrink-0 w-24 text-sm font-medium text-gray-700">
                Parcela {index + 1}
              </span>
              <DatePicker
                selected={date}
                onChange={(d) => handleDateChange(d, index)}
                dateFormat="dd/MM/yyyy"
                className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              <span className="text-xs text-gray-400 flex-shrink-0 hidden sm:block w-36">
                {date.toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' })}
              </span>
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={() => onComplete({ ...initialLoan, installmentDates: dates, ruta: sellerRuta })}
        className="w-full py-4 bg-blue-600 text-white rounded-xl font-semibold text-base hover:bg-blue-700 transition-colors shadow-sm"
      >
        Continuar
      </button>
    </div>
  );
}
